module.exports = __webpack_public_path__ + "media/images/number_30-c0c052434db90c31542c62db56fd7f2f.png";